import { render, staticRenderFns } from "./PricesEntity.vue?vue&type=template&id=a6cb8d0c&"
import script from "./PricesEntity.vue?vue&type=script&lang=js&"
export * from "./PricesEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports